import React, { ReactElement, useState } from 'react';

import { createCtx } from 'helpers/createCtx';
import { Modal } from 'components/Modal';

type ModalSize = 'large' | 'small' | 'mini' | 'tiny' | 'fullscreen' | undefined;

type ContextType = {
  modal: boolean;
  handleModal: (content?: any, size?: ModalSize) => void;
  size: ModalSize;
  modalContent: any;
};

const [useModal, CtxProvider] = createCtx<ContextType>();

type Props = {
  children: React.ReactNode;
};

const ModalProvider = ({ children }: Props): ReactElement => {
  const [size, setSize] = useState<ModalSize>('large');
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState<any>();

  const handleModal = (content?: any, newSize?: ModalSize) => {
    if (content) {
      setModalContent(content);
      setModal(true);
    } else {
      setModalContent(null);
      setModal(false);
    }
    setSize(newSize || 'large');
  };

  return (
    <CtxProvider value={{ modal, handleModal, size, modalContent }}>
      <Modal />
      {children}
    </CtxProvider>
  );
};

export { useModal, ModalProvider };
